import axios from 'axios';
import config from '../../../config/config';

/**
 * Utility function to convert PascalCase to camelCase recursively
 * Handles objects and arrays from C# backend to JavaScript frontend conventions
 */
const pascalToCamel = (obj: any): any => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(pascalToCamel);
  }

  const converted: any = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      // Convert PascalCase to camelCase
      const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
      converted[camelKey] = pascalToCamel(obj[key]);
    }
  }

  return converted;
};

const axiosClient = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: config.defaultTimeout,
  transformResponse: [
    (data) => {
      // Convert JSON string to object if needed
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch {
          return data;
        }
      }
      // Convert PascalCase to camelCase
      return pascalToCamel(data);
    }
  ]
});

// Add request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('🔍 Axios Request - URL:', config.url);
    console.log('🔍 Axios Request - Method:', config.method);
    console.log('🔍 Axios Request - Token exists:', !!token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔍 Axios Request - Token (first 20 chars):', token.substring(0, 20) + '...');
    } else {
      console.log('🔴 Axios Request - No token found in localStorage');
    }
    return config;
  },
  (error) => {
    console.error('🔴 Axios Request Interceptor Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor
axiosClient.interceptors.response.use(
  (response) => {
    console.log('🟢 Axios Response Success - URL:', response.config.url);
    console.log('🟢 Axios Response Success - Status:', response.status);
    return response;
  },
  async (error) => {
    console.error('🔴 Axios Response Error - URL:', error.config?.url);
    console.error('🔴 Axios Response Error - Status:', error.response?.status);
    console.error('🔴 Axios Response Error - Data:', error.response?.data);
    console.error('🔴 Axios Response Error - Headers:', error.response?.headers);
    
    if (error.response?.status === 401) {
      console.error('🔴 401 Unauthorized - Removing token and redirecting');
      // Handle unauthorized access
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
